import React from 'react';
import './style.scss';
export interface SwitchButtonProps {
  isToggled?: boolean;
  onToggle?: (node) => void;
  customStyle?: React.CSSProperties;
}
const SwitchButton = (props: SwitchButtonProps) => {
  const { isToggled, customStyle, onToggle } = props;
  return (
    <label id="switch-button-label" style={customStyle} className="switch">
      <input
        id="switch-button-checkbox"
        type="checkbox"
        checked={isToggled}
        onChange={onToggle}
      />
      <span id="switch-button-rounded-slider" className="rounded slider" />
    </label>
  );
};

export default SwitchButton;
